////////LIBRARY/////////
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

/////////STYLED/////////
const ToggleInputWrapper = styled.div`
	display: flex;
	align-items: center;
`
const Slider = styled.span`
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	-webkit-transition: 0.4s;
	transition: 0.4s;
	border-radius: 13px;
	border: 1px solid ${(props) => (props.prevColor ? props.prevColor : props.theme.colors.error)};
	::before {
		position: absolute;
		content: '';
		height: 20px;
		width: 20px;
		left: 4px;
		bottom: 3px;
		background-color: ${(props) => (props.prevColor ? props.prevColor : props.theme.colors.error)};
		-webkit-transition: 0.4s;
		transition: 0.4s;
		border-radius: 13px;
		top: 50%;
		transform: translateY(-50%) translateX(0);
	}
`
const SwitchToggle = styled.label`
	position: relative;
	display: inline-block;
	width: 56px;
	height: 26px;
`
const InputSwitchToggle = styled.input`
	opacity: 0;
	width: 0;
	height: 0;
	:checked + ${Slider} {
		background-color: ${(props) => props.theme.colors.white};
		border: 1px solid ${(props) => props.theme.colors.primary};
	}
	margin: 0px;
	border: 1px solid transparent;
	:focus + ${Slider} {
		box-shadow: 0 0 1px ${(props) => props.theme.colors.primary};
	}
	:checked + ${Slider}:before {
		transform: translateY(-50%) translateX(26px);
		background-color: ${(props) => props.theme.colors.primary};
	}
`
const ToggleLabelPrev = styled.label`
	margin: 0px 5px;
	color: ${(props) => (!props.isChecked ? props.theme.colors.error : props.theme.colors.eraser)};
`
const ToggleLabelNext = styled.label`
	margin: 0px 5px;
	color: ${(props) => (props.isChecked ? props.theme.colors.primary : props.theme.colors.eraser)};
`
/////////STYLED/////////

/**
 *
 * @param checked
 * @param onChangeHandler
 * @param id
 * @returns {*}
 */
const ToggleInput = ({ checked, onChangeHandler, name, labelPrev, labelNext, prevColor = '' }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ToggleInputWrapper>
			{labelPrev && <ToggleLabelPrev isChecked={checked}>{labelPrev.length > 0 ? labelPrev : 'OFF'}</ToggleLabelPrev>}
			<SwitchToggle>
				<InputSwitchToggle checked={checked} type={'checkbox'} onChange={() => onChangeHandler()} name={name} />
				<Slider prevColor={prevColor} />
			</SwitchToggle>
			{labelNext && <ToggleLabelNext isChecked={checked}>{labelNext.length > 0 ? labelNext : 'ON'}</ToggleLabelNext>}
		</ToggleInputWrapper>
	)
}

ToggleInput.propTypes = {
	checked: PropTypes.bool,
	onChangeHandler: PropTypes.func,
	id: PropTypes.number,
}

export default ToggleInput
